import React from 'react'

export default (props: any) => (
  <svg {...props} width="66" height="51" viewBox="0 0 66 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.5727 0.964043L22.524 49.869L43.784 49.8902L43.8326 0.985193L22.5727 0.964043Z" fill="#FFDA44" />
    <path d="M43.8476 0.986077L43.799 49.8911L65.191 49.9123L65.2396 1.00736L43.8476 0.986077Z" fill="#D80027" />
    <path d="M1.19865 1.19103L1.15 50.096L22.41 50.1172L22.4586 1.21218L1.19865 1.19103Z" fill="#0052B4" />
    <path d="M65.5 0.5H0.5V50.5H65.5V0.5Z" stroke="#9F9D9D" />
  </svg>
)
